import { CssBaseline, Grid } from "@material-ui/core";
import { WhatsApp } from "@material-ui/icons";
import React, { useEffect } from "react";
import { useState } from "react";
import { getPlacesdate, getwhaterdatav } from "./APi";
import Header from "./Componentes/Header/Header";
import List from "./Componentes/List/List";
import Map from "./Componentes/Map/Map";

import PlaceDetiels from "./Componentes/placeDetailes/PlaceDetiels";
function App() {
  const [childcliked, setchildcliked] = useState(null)
  const [places, setplaces] = useState([]);
const [cordinates, setcordinates] = useState({})
//bounds are are top right and bottom left corner of the map
const [bounds, setbounds] = useState(null)
const [loding, setloding] = useState(false)
const [Type, setType] = useState("restaurants");
  const [rating, setrating] = useState("");
//getting the user current location 
const [filltered, setfilltered] = useState([])
const [watherdata, setwatherdata] = useState([])
console.log(process.env.REACT_APP_RAPIDE_WEATHER_API_KEY)
useEffect(() => {

navigator.geolocation.getCurrentPosition(({coords:{latitude,longitude}})=>{
  //setting users current latitude and longitude to cordiates
setcordinates({lat:latitude,lng:longitude})
})

}, [])

useEffect(() => {
const Filterplace = places?.filter((place)=>place.rating > rating)
setfilltered(Filterplace)

}, [rating])

console.log(watherdata)

//calling apis
  useEffect(() => {
    if(bounds?.sw && bounds?.ne){
       setloding(true)
getwhaterdatav(cordinates.lng,cordinates.lat).then((data)=>{
setwatherdata(data)
})

    getPlacesdate(Type,bounds?.sw,bounds?.ne).then((data) => {
   
      setplaces(data?.filter(place=>place.name&&place.num_reviews > 0));
      setfilltered([])
      setloding(false)
    });
    }

  }, [bounds,Type]);
    const [autocomplete, setAutocomplete] = useState(null);
  console.log(bounds)

  return (
    <>
      <CssBaseline />
      {/*  @param CssBaseline set all the margin color of the browser for us  */}
      <Header />
      <Grid container spacing={3} style={{ width: "100%" }}>
        <Grid item xs={12} md={4}>
          {/* xs = 12 this grid take full width  on mobile devices md =4 menas its only going to 4 space  */}

          <List places={filltered?.length ? filltered :  places} 
          childcliked={childcliked}
          isloading={loding}
          type={Type}
          setType={setType}
          rating={rating}
          setrating={setrating}
          />
        </Grid>
        <Grid item xs={12} md={8}>
          {/* xs = 12 this grid take full width  on mobile devices md =4 menas its only going to 4 space  */}

          <Map setCoordinates={setcordinates}
          setBounds={setbounds}
          cordinates={cordinates}
         places={ filltered?.length ? filltered :  places}
         setchildcliked = {setchildcliked}
        weatherData={watherdata}
          />
        </Grid>
      </Grid>
    </>
  );
}

export default App;
